export const RANKS = [[3, "Best"], [2, "Good"], [1, "Weak"], [0, "Worst"]];
export const SC_TYPES = { team: "Teamwork", conflict: "Conflict", leadership: "Leadership", change: "Change" };
const KIND = { single: "Multiple choice", multi: "Multiple choice (several)", short: "Short answer", text: "Long answer", yesno: "Yes / No" };

export const kindLabel = (item, secType) => (secType === "scenarios" ? `Scenario · ${SC_TYPES[item.type] || item.type}` : KIND[item.kind]);
export const itemText = (item, secType) => (secType === "scenarios" ? item.scenario : item.prompt);
export const isKeyed = (q) => ["single", "multi", "yesno"].includes(q.kind);
export const isScored = (q, secType) => secType === "quiz" || q.scored;

// Per-field issues, keyed by field, in plain words. Empty object = complete.
export function issues(item, secType) {
  const out = {};
  if (secType === "scenarios") {
    if (!item.scenario?.trim()) out.prompt = "Write the situation the candidate reads.";
    const empty = item.options.map((o, i) => (!o.text?.trim() ? i + 1 : null)).filter(Boolean);
    if (empty.length) out.options = `Write response ${empty.join(", ")}.`;
    const ranks = item.options.map((o) => o.score).sort().join();
    if (ranks !== "0,1,2,3") out.ranks = "Use each rank once: Best, Good, Weak and Worst.";
    return out;
  }
  if (!item.prompt?.trim()) out.prompt = "Write the question.";
  const scored = isScored(item, secType);
  if (["single", "multi"].includes(item.kind)) {
    if (item.options.length < 2) out.options = "Add at least 2 answer options.";
    else if (item.options.some((o) => !o.text?.trim())) out.options = "Fill in every answer option, or remove the empty one.";
  }
  if (scored && isKeyed(item)) {
    const n = item.options.filter((o) => o.correct).length;
    if (!n) out.key = "Tick the correct answer.";
    else if (item.kind !== "multi" && n > 1) out.key = "Only one answer can be correct. Switch to 'several correct' or untick one.";
  }
  if (scored && !isKeyed(item) && !item.model_answer?.trim()) out.model = "Add a model answer so written answers can be scored.";
  return out;
}

export const rid = () => Math.random().toString(36).slice(2, 10);

// Assign a rank to one response; the response that had it takes the old rank (auto-swap).
export function setRank(options, idx, score) {
  const old = options[idx].score;
  return options.map((o, i) => (i === idx ? { ...o, score } : o.score === score ? { ...o, score: old } : o));
}

export const duplicate = (item) => ({ ...JSON.parse(JSON.stringify(item)), id: rid(), options: (item.options || []).map((o) => ({ ...o, id: rid() })) });
